const ActionToolType = {
  filter: "filter",
  data: "data",
  geozones: "geozones",
  documents: "documents",
  trackers: "trackers",
};

export default ActionToolType;
